/**
 * @file Re-exports EmailTemplatePreview as the entry point of the module.
 */
import EmailTemplatePreview from "./EmailTemplatePreview";

export default EmailTemplatePreview;
